/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store( 'biom-navigation', {
	state: {
		get currentlyOpened() {
			return state.currentlyOpened;
		},
		get themeText() {
			return state.isDark ? state.darkText : state.lightText;
		},
        get type() {
            const { isSearchInputVisible } = getContext();
            return isSearchInputVisible ? 'submit' : 'button';
        },
	},
	actions: {
		toggleSubmenu(event) {
            const context = getContext();
            const { ref } = getElement();
            
            let header = document.getElementsByClassName("biom-header")[0].parentElement;
            var rect = header.getBoundingClientRect();
            //var wpadminbar = document.querySelector("#wpadminbar")

    	    context.desktopMenu.forEach((el) => {
                    if (el.id == ref.id && !el.is_url) {
                        el.hidden = !el.hidden;
                        if (el.hidden) {
                            let submenu = ref.querySelector(".desktop-submenu");
                            submenu.style.left = rect.left+'px';
                            submenu.style.top = (rect.bottom - rect.top)+'px';
                            submenu.style.width = (rect.right - rect.left)+'px';
                        }
                    } else {
                        el.hidden = false;
                    }
            });
		},
		toggleSubsubmenu(event) {
            const context = getContext();
            const { ref } = getElement();
            
            let parent_div = ref.parentElement.parentElement.parentElement;
            var rect = parent_div.getBoundingClientRect();
    	    
            context.desktopMenu.forEach((el) => {
                    if (el.id == parent_div.id) {
                        el.hidden = false;
                        el.submenu_items.forEach((sub) => {
                            if (sub.id == ref.id && !sub.is_url) {
                                sub.hidden = !sub.hidden;
                                if (sub.hidden) {
                                    let subsubmenu = ref.querySelector(".desktop-subsubmenu");
                                    subsubmenu.style.left = rect.left+'px';
                                    subsubmenu.style.top = (rect.bottom - rect.top)+'px';
                                    subsubmenu.style.width = (rect.right - rect.left)+'px';
                                }
                            } else {
                                sub.hidden = false;
                            }
                        });
                    } else {
                        el.hidden = false;
                    }
            });
        },
		toggleMobile(event) {
			const context = getContext();
			context.isMobileOpened = ! context.isMobileOpened;
		},
		toggleMobileSubmenu(event) {
            const context = getContext();
            const { ref } = getElement();
            let items_closed = context.mobileMenu.filter(
                (el) => el.hidden == true
            ).length;
            if (items_closed == 0) {
    			context.mobileMenu.forEach((el) => {
                    el.hidden = true;
                    if (el.id == ref.id && !el.is_url) {
                        context.isMobileSubmenuOpened = true;
                        context.mobileMenuActive = el;
                        context.mobileMenuActiveLabel = "← " + el.label;
                        context.mobileMenuActiveSubmenu = el.submenu_items;
                    }
                });
            } else {
                context.mobileMenu.forEach((el) => {
                    el.hidden = false;
                    context.isMobileSubmenuOpened = false;
                    context.mobileMenuActive = [];
                    context.mobileMenuActiveSubmenu = [];
                });
            }
        },
		toggleMobileSubsubmenu(event) {
            const context = getContext();
            const { ref } = getElement();
            if (context.isMobileSubmenuOpened) {
                let items_closed = context.mobileMenuActive.submenu_items.filter(
                    (el) => el.hidden == true
                ).length;
                if (items_closed == 0) {
                    context.mobileMenuActive.submenu_items.forEach((el) => {
                        el.hidden = true;
                        if (el.id == ref.id) {
                            el.hidden = true;
                            context.mobileMenuActiveLabel = "← " + el.label;
                            context.mobileMenuActiveSubmenu = el.submenu_items;
                        }
                    });
                } else {
                    context.mobileMenuActiveSubmenu.forEach((el) => {
                        el.hidden = false;
                        context.mobileMenuActiveSubmenu = context.mobileMenuActive.submenu_items;
                    });
                }
            }
        },
        openSearchInput( event ) {
            const ctx = getContext();
            const { ref } = getElement();
            if ( ! ctx.isSearchInputVisible ) {
                event.preventDefault();
                ctx.isSearchInputVisible = true;
                ref.parentElement.querySelector( 'input' ).focus();
            }
        },
        closeSearchInput() {
            const ctx = getContext();
            ctx.isSearchInputVisible = false;
        },
        handleSearchKeydown( event ) {
            const { ref } = getElement();
            if ( event?.key === 'Escape' ) {
                actions.closeSearchInput();
                ref.querySelector( 'button' ).focus();
            }
        },
        handleSearchFocusout( event ) {
            const { ref } = getElement();
            if (
                ! ref.parentElement.contains( event.relatedTarget ) &&
                event.target !== window.document.activeElement
            ) {
                actions.closeSearchInput();
            }
        },
	},
	callbacks: {
		logIsOpen: () => {
            const context = getContext();
            console.log(context.isMobileOpened);
		},
        changeToFullWidth: () => {
            const context = getContext();
            const { ref } = getElement();
            window.addEventListener("resize", event => { resize_submenu(ref) });

            function resize_submenu(submenu) {
                let header = document.getElementsByClassName("biom-header")[0].parentElement;
                var rect = header.getBoundingClientRect();
                submenu.style.left = rect.left+'px';
                submenu.style.top = (rect.bottom - rect.top)+'px';
                submenu.style.width = (rect.right - rect.left)+'px';
            };
        },
	},
} );
